import { render, staticRenderFns } from "./FidelityDetail.vue?vue&type=template&id=54cb9882&scoped=true"
import script from "./FidelityDetail.vue?vue&type=script&lang=js"
export * from "./FidelityDetail.vue?vue&type=script&lang=js"
import style0 from "./FidelityDetail.vue?vue&type=style&index=0&id=54cb9882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb9882",
  null
  
)

export default component.exports